import type {
  IAdapterConfig,
  MiddlewareConfigClass
} from '@care-portals/api-interfaces';

const config = {
  phytogenix: {
    label: 'Phytogenix Pharmacy',
    functions: {
      CreateOrder: {
        middlewareHandler: 'phytogenix',
        version: 2,
        label: 'Create Order',
        pipelines: ['order'],
        passPayload: true,
        params: []
      },
      HandleWebhook: {
        middlewareHandler: 'phytogenix',
        version: 2,
        label: 'Handle Webhook',
        pipelines: ['webhook'],
        passPayload: true,
        params: []
      }
    }
  }
} as const;

export const PhytogenixConfig: IAdapterConfig = {
  ...config
} as unknown as IAdapterConfig;

export type PhytogenixFunctionConfiguration = MiddlewareConfigClass<
  typeof config.phytogenix.functions
>;
